import React from "react";

function article_1() {
	return {
		date: "2 de Maio 2024",
		title: "Os Benefícios da Computação em Nuvem",
		description:
			"A computação em nuvem oferece uma variedade de benefícios, incluindo economia de custos e maior flexibilidade. Descubra por que mais empresas estão recorrendo à nuvem.",
		keywords: [
			"The Benefits of Cloud Computing",
			"Os Benefícios da Computação em Nuvem",
			" Computação em Nuvem",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">Página em atualização</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "4 de Maio 2024",
		title: "Ecossistema Apple",
		description:
			"Explore o ecossistema integrado da Apple para conexão de dispositivos, desde iPhones e iPads até Apple Watches e Macs. Descubra como essa integração revolucionou a forma como interagimos com nossos dispositivos diariamente.",
		style: ``,
		keywords: [
			"Ecossistema Apple",
			"Conexão de Dispositivos Apple",
			"Integração de Dispositivos Apple",
		],
		body: (
			<React.Fragment>
				<h1>Página em atualizaçãoo</h1>
			</React.Fragment>
		),
	};
}

const myArticles = [article_1, article_2];

export default myArticles;
